import { useHistory, useLocation } from "react-router-dom";

import logo from "../../../Assets/applifecycle/appicon-placeholder.svg";
import styles from "./AppCard.module.scss";
import { sliceString } from "../../../util/helpers/funcHelper";
import { getStatus } from "../../../util/helpers/funcHelper";
import { appStatus } from "../../../util/helpers/statusHelper";
import { AuthImage } from "../../common/AuthImage";
const AppCard = ({ app }) => {
  const history = useHistory();
  const location = useLocation();
  let styleName   = styles.app_lite
  switch (app.platform) {
    case "LITE":
      styleName = styles.app_lite
      break;
    case "PRO":
      styleName = styles.app_pro
      break;
    case "HOLOBOARD":
      styleName = styles.app_holoboard
      break;
    case "CARDBOARD":
      styleName = styles.app_cardboard
      break;
    default:
      styleName = styles.app_lite
      break;
  }

  return (
    <div
      onClick={() => history.push(`${location.pathname}/${app.id}`)}
      className={styles.appcard}
    >
      <span className={`${styles.color_border} ${styleName}`}>
      </span>
      <div className="pl-15">
        <div className={styles.headingcontainer}>

          <AuthImage
            src={app?.builds?.[0]?.graphics?.appIcon?.url}
            fallback={logo}
            alt="applogo"
          />
          <h4>{sliceString(0,19,app.title,true)}</h4>
        </div>
        <span>
          <span className="">Created date: {app.created_at}</span>
        </span>
        <div className={styles.statuscontainer}>
          <>{getStatus(app?.status,appStatus?.app,true)}</>
          {app.category && app.category.name ?
            <span
              style={{
                backgroundColor:
                  app?.category?.name === "Gaming"
                    ? "#db6a18"
                    : app?.category?.name === "Entertainment"
                      ? "#179cad"
                      : app?.category?.name === "Learning"
                        ? "#4096ef"
                        : app?.category?.name === "Health & Wellness"
                          ? "#276fd1"
                          : app?.category?.name === "Shopping"
                            ? "#b538db"
                            : app?.category?.name === "Productivity"
                              ? "#7758de"
                              : "#707070",
                display: app?.category ? true : false
              }}
              className={styles.category}
            >
              {app.category.name}
            </span>:null}
        </div>
      </div>
    </div>
  );
};

export default AppCard;